import { GatewayApiClient } from "@radixdlt/babylon-gateway-api-sdk";
import { RADIX_GATEWAY_URL } from "~/lib/util";

console.log('RADIX_GATEWAY_URL', RADIX_GATEWAY_URL);

export const useGatewayApi = GatewayApiClient.initialize({
	basePath: RADIX_GATEWAY_URL,
	applicationName: 'DefiPlaza'
});
